import React from 'react';
import { useTranslator } from 'tradera-lang';
import StarIcon from '@tradera/blueprint/theme/icons2/star.svg?jsx';
import './favourite-sellers.scss';

const FavouriteSellersFallback = () => {
    const { t } = useTranslator();

    return (
        <div className="m-3 m-md-2 p-4 bg-light d-flex flex-column align-items-center">
            <span className="mb-4">
                {t('startPage_favoriteSeller_fallback_text1')}
            </span>

            <div className="favourite-sellers-fallback-button">
                <button className="btn btn-primary d-flex text-white pointer-events-none align-items-center">
                    <StarIcon className="icon icon-md mr-2" />
                    {t('startPage_favoriteSeller_fallback_button')}
                </button>

                <img
                    className="favourite-sellers-fallback-button-pointer"
                    src="/static/images/my-tradera/mouse-pointer-hover.png"
                />
            </div>
            <span className="mb-4">
                {t('startPage_favoriteSeller_fallback_text2')}
            </span>
        </div>
    );
};

export default FavouriteSellersFallback;
